module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/voice-01-037d3992a720c2b2961acdcacc726be9.svg";